/* eslint-disable indent */
'use client';

import { usePathname } from 'next/navigation';
import DynamicJsonLd from './dynamic-json-ld';

export default function BlogSeo({ isBlog = false, blog }) {
  const pathname = usePathname();

  // For blog, we'll use the Blog schema
  if (isBlog && blog) {
    const blogData = {
      '@context': 'https://schema.org',
      '@type': 'BlogPosting',
      headline: blog.title,
      image: blog.image || 'https://images.x-space.ae/assets/images/Logo-B.png',
      datePublished: blog.publishedAt || new Date().toISOString(),
      dateModified: blog.publishedAt || new Date().toISOString(),
      author: blog.author
        ? {
            '@type': 'Person',
            name: blog.author.name,
            url: `https://x-space.ae/blog/${blog.author.slug}`,
          }
        : {
            '@type': 'Organization',
            name: 'X-SPACE Real Estate',
            url: 'https://x-space.ae',
          },
      publisher: {
        '@type': 'Organization',
        name: 'X-SPACE Real Estate',
        logo: {
          '@type': 'ImageObject',
          url: 'https://images.x-space.ae/assets/images/Logo-B.png',
        },
      },
      description:
        blog.description || 'Read our latest blog about Dubai real estate.',
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': `https://x-space.ae${pathname}`,
      },
    };

    return <DynamicJsonLd type='all' pathname={pathname} data={blogData} />;
  }

  // For the blog index page, we'll use the standard website schema
  return <DynamicJsonLd type='all' pathname={pathname} />;
}
